<template>
    <div>
        <search-bar></search-bar>
        <domiciliation-contracts-table></domiciliation-contracts-table>
    </div>
</template>

<script type="text/babel">
    import SearchBar from '../../components/DomiciliationContractsList/SearchBar'
    import DomiciliationContractsTable from '../../components/DomiciliationContractsList/DomiciliationContractsTable'
    export default {
      name: "DomiciliationContractsList",
        components: {
            SearchBar,
            DomiciliationContractsTable
        }
    }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// client/views/DomiciliationContracts/DomiciliationContractsList.vue